export default "__VITE_ASSET__p8pJftH4__"